export const howQuestions = [
  {
    questionNumber: 1,
    questionText: "How do I reset my company password?",
    choices: {
      A: "I received the new policy yesterday.",
      B: 'Click "Forgot Password" on the login screen.',
      C: "Yes, it's quite secure.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회사 비밀번호를 어떻게 재설정하나요?",
      choices: {
        A: "어제 새 정책을 받았습니다.",
        B: '로그인 화면에서 "비밀번호 찾기"를 클릭하세요.',
        C: "네, 매우 안전합니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 비밀번호 재설정 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 2,
    questionText: "How should I apply for the internal position?",
    choices: {
      A: "Submit your resume to HR by Friday.",
      B: "Yes, I saw the job post.",
      C: "It's on the second floor.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "내부 직책에 어떻게 지원해야 하나요?",
      choices: {
        A: "금요일까지 인사부에 이력서를 제출하세요.",
        B: "네, 채용 공고를 봤습니다.",
        C: "2층에 있습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 내부 직책 지원 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 3,
    questionText: "How can we improve team communication?",
    choices: {
      A: "We had a meeting last Thursday.",
      B: "I prefer using email.",
      C: "Let's try using a group chat platform.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "팀 의사소통을 어떻게 개선할 수 있을까요?",
      choices: {
        A: "지난 목요일에 회의가 있었습니다.",
        B: "저는 이메일 사용을 선호합니다.",
        C: "그룹 채팅 플랫폼을 사용해 보는 게 어떨까요.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 해결책이나 방법을 제시해야 합니다. C는 팀 의사소통 개선을 위한 구체적인 방안을 제안하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 4,
    questionText: "How do I check the delivery status?",
    choices: {
      A: "Use the tracking number on the website.",
      B: "The package is quite large.",
      C: "Yes, I checked already.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "배송 상태를 어떻게 확인하나요?",
      choices: {
        A: "웹사이트에서 운송장 번호를 사용하세요.",
        B: "패키지가 꽤 큽니다.",
        C: "네, 이미 확인했습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 배송 상태 확인 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 5,
    questionText: "How should I format the monthly report?",
    choices: {
      A: "In landscape mode with charts on the last page.",
      B: "Yes, it's a monthly summary.",
      C: "The report was approved.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "월간 보고서를 어떻게 포맷해야 하나요?",
      choices: {
        A: "가로 모드로 하고 차트는 마지막 페이지에 배치하세요.",
        B: "네, 월간 요약입니다.",
        C: "보고서가 승인되었습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 형식이나 방법을 설명해야 합니다. A는 보고서 포맷에 대한 구체적인 지침을 제공하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 6,
    questionText: "How do we get a refund for the canceled order?",
    choices: {
      A: "You'll need to contact customer service directly.",
      B: "The cancellation was confirmed.",
      C: "No, we didn't receive a refund yet.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "취소된 주문에 대한 환불을 어떻게 받나요?",
      choices: {
        A: "고객 서비스에 직접 연락해야 합니다.",
        B: "취소가 확인되었습니다.",
        C: "아니요, 아직 환불을 받지 못했습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 환불 받는 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 7,
    questionText: "How can I print from my laptop?",
    choices: {
      A: "Connect to the office Wi-Fi and use the print app.",
      B: "My laptop is brand new.",
      C: "It's already printed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "노트북에서 어떻게 인쇄할 수 있나요?",
      choices: {
        A: "사무실 와이파이에 연결하고 인쇄 앱을 사용하세요.",
        B: "제 노트북은 아주 새것입니다.",
        C: "이미 인쇄되었습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 노트북에서 인쇄하는 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 8,
    questionText: "How do I schedule a meeting with Mr. Lee?",
    choices: {
      A: "I met him last week.",
      B: "Check his calendar and send an invite.",
      C: "He's in a meeting now.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 씨와 회의 일정을 어떻게 잡나요?",
      choices: {
        A: "저는 지난주에 그를 만났습니다.",
        B: "그의 일정을 확인하고 초대장을 보내세요.",
        C: "그는 지금 회의 중입니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 회의 일정을 잡는 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 9,
    questionText: "How should I send the invoice?",
    choices: {
      A: "You can fax it to the billing department.",
      B: "It's already been paid.",
      C: "Email it as a PDF file by 5 p.m.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "청구서를 어떻게 보내야 하나요?",
      choices: {
        A: "청구 부서로 팩스를 보낼 수 있습니다.",
        B: "이미 지불되었습니다.",
        C: "오후 5시까지 PDF 파일로 이메일을 보내세요.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. C는 청구서를 보내는 방법과 형식, 기한을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 10,
    questionText: "How can I change my shift schedule?",
    choices: {
      A: "Yes, the schedule was updated.",
      B: "Submit a request through the HR portal.",
      C: "It starts at 9 a.m.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "근무 일정을 어떻게 변경할 수 있나요?",
      choices: {
        A: "네, 일정이 업데이트되었습니다.",
        B: "인사 포털을 통해 요청서를 제출하세요.",
        C: "오전 9시에 시작합니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 근무 일정 변경 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 11,
    questionText: "How do I update my contact information?",
    choices: {
      A: "The form is on the company portal.",
      B: "I don't have your number.",
      C: "Yes, I updated it yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "연락처 정보를 어떻게 업데이트하나요?",
      choices: {
        A: "양식은 회사 포털에 있습니다.",
        B: "당신의 번호가 없습니다.",
        C: "네, 어제 업데이트했습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 연락처 정보 업데이트 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 12,
    questionText: "How can I join the video meeting?",
    choices: {
      A: "It starts in 10 minutes.",
      B: "Click the link in the invitation email.",
      C: "I already joined.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "화상 회의에 어떻게 참여할 수 있나요?",
      choices: {
        A: "10분 후에 시작합니다.",
        B: "초대 이메일의 링크를 클릭하세요.",
        C: "저는 이미 참여했습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 화상 회의 참여 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 13,
    questionText: "How should I label the new files?",
    choices: {
      A: "With dates and department names.",
      B: "The files are on my desk.",
      C: "I labeled them blue.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새 파일에 어떻게 라벨을 붙여야 하나요?",
      choices: {
        A: "날짜와 부서명으로 라벨을 붙이세요.",
        B: "파일들은 제 책상 위에 있습니다.",
        C: "파일에 파란색으로 라벨을 붙였습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 파일 라벨링 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 14,
    questionText: "How do we order more supplies?",
    choices: {
      A: "Use the online order form.",
      B: "Supplies were delivered yesterday.",
      C: "Yes, I placed the order.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "물품을 더 주문하려면 어떻게 해야 하나요?",
      choices: {
        A: "온라인 주문 양식을 사용하세요.",
        B: "물품은 어제 배달되었습니다.",
        C: "네, 주문을 넣었습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 물품 주문 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 15,
    questionText: "How can I get reimbursed for travel expenses?",
    choices: {
      A: "I booked the flight online.",
      B: "Submit your receipts to the finance team.",
      C: "It was an expensive trip.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "출장 비용을 어떻게 환급받을 수 있나요?",
      choices: {
        A: "온라인으로 항공권을 예약했습니다.",
        B: "영수증을 재무팀에 제출하세요.",
        C: "비용이 많이 드는 출장이었습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 출장 비용 환급 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 16,
    questionText: "How do I schedule a client call?",
    choices: {
      A: "He called this morning.",
      B: "Use the shared calendar to find an open slot.",
      C: "The call went well.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객과의 통화 일정을 어떻게 잡나요?",
      choices: {
        A: "그는 오늘 아침에 전화했습니다.",
        B: "공유 캘린더를 사용하여 빈 시간을 찾으세요.",
        C: "통화가 잘 진행되었습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 고객 통화 일정 잡는 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 17,
    questionText: "How should we decorate the conference room?",
    choices: {
      A: "I reserved it for Monday.",
      B: "With company banners and fresh flowers.",
      C: "It's a small room.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회의실을 어떻게 꾸며야 할까요?",
      choices: {
        A: "월요일에 예약했습니다.",
        B: "회사 배너와 생화로 꾸미세요.",
        C: "작은 방입니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 회의실 장식 방법을 구체적으로 제안하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 18,
    questionText: "How can I turn off the alarm system?",
    choices: {
      A: "Press 7 and then enter the code.",
      B: "It's loud.",
      C: "The alarm went off.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "경보 시스템을 어떻게 끌 수 있나요?",
      choices: {
        A: "7을 누른 다음 코드를 입력하세요.",
        B: "소리가 큽니다.",
        C: "경보가 울렸습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 경보 시스템을 끄는 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 19,
    questionText: "How do I sign up for the newsletter?",
    choices: {
      A: "The newsletter was just sent.",
      B: "Visit our website and fill out the form.",
      C: "Yes, I read it.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "뉴스레터를 어떻게 구독하나요?",
      choices: {
        A: "뉴스레터가 방금 발송되었습니다.",
        B: "웹사이트를 방문하여 양식을 작성하세요.",
        C: "네, 읽었습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 뉴스레터 구독 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 20,
    questionText: "How can we make the presentation more engaging?",
    choices: {
      A: "That's a great presentation.",
      B: "Add visuals and interactive polls.",
      C: "I watched it twice.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프레젠테이션을 어떻게 더 흥미롭게 만들 수 있을까요?",
      choices: {
        A: "훌륭한 프레젠테이션입니다.",
        B: "시각 자료와 대화형 설문을 추가하세요.",
        C: "두 번 봤습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 프레젠테이션을 더 흥미롭게 만드는 방법을 구체적으로 제안하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 21,
    questionText: "How do I cancel a meeting in Outlook?",
    choices: {
      A: "Click Cancel Meeting in the calendar event.",
      B: "I had a meeting earlier.",
      C: "Meetings are often rescheduled.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "Outlook에서 회의를 어떻게 취소하나요?",
      choices: {
        A: '캘린더 이벤트에서 "회의 취소"를 클릭하세요.',
        B: "일찍 회의가 있었습니다.",
        C: "회의는 종종 일정이 변경됩니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 Outlook에서 회의 취소 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 22,
    questionText: "How should I send a formal invitation?",
    choices: {
      A: "Send it through email with the agenda attached.",
      B: "I was invited.",
      C: "The event is tomorrow.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "공식 초대장을 어떻게 보내야 하나요?",
      choices: {
        A: "의제를 첨부하여 이메일로 보내세요.",
        B: "저는 초대받았습니다.",
        C: "행사는 내일입니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 공식 초대장 발송 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 23,
    questionText: "How do we improve our social media presence?",
    choices: {
      A: "Post regularly and engage with followers.",
      B: "Social media is popular.",
      C: "Yes, I follow that page.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "소셜 미디어 존재감을 어떻게 향상시킬 수 있을까요?",
      choices: {
        A: "정기적으로 게시하고 팔로워와 소통하세요.",
        B: "소셜 미디어는 인기가 있습니다.",
        C: "네, 저는 그 페이지를 팔로우합니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 소셜 미디어 존재감 향상 방법을 구체적으로 제안하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 24,
    questionText: "How can I apply for a parking permit?",
    choices: {
      A: "You need to fill out the online form.",
      B: "Parking is usually full before 9 a.m.",
      C: "The security guard leaves at 6 p.m.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "주차 허가증을 어떻게 신청할 수 있나요?",
      choices: {
        A: "온라인 양식을 작성해야 합니다.",
        B: "주차장은 보통 오전 9시 전에 만차가 됩니다.",
        C: "경비원은 오후 6시에 퇴근합니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 주차 허가증 신청 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 25,
    questionText: "How do I join the company gym?",
    choices: {
      A: "There's a gym on the second floor.",
      B: "Register at the front desk and sign a waiver.",
      C: "Yes, I already went today.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회사 체육관에 어떻게 가입하나요?",
      choices: {
        A: "2층에 체육관이 있습니다.",
        B: "안내 데스크에서 등록하고 면책 동의서에 서명하세요.",
        C: "네, 오늘 이미 다녀왔습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 회사 체육관 가입 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 26,
    questionText: "How can I track my work hours?",
    choices: {
      A: "Use the time-logging app installed on your phone.",
      B: "My hours vary.",
      C: "It's past 5 p.m.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "근무 시간을 어떻게 기록할 수 있나요?",
      choices: {
        A: "휴대폰에 설치된 시간 기록 앱을 사용하세요.",
        B: "제 근무 시간은 다양합니다.",
        C: "오후 5시가 지났습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 근무 시간 기록 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 27,
    questionText: "How do we confirm the delivery time?",
    choices: {
      A: "The delivery truck is red.",
      B: "Call the vendor to double-check the schedule.",
      C: "Yes, I confirmed it.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "배송 시간을 어떻게 확인하나요?",
      choices: {
        A: "배송 트럭은 빨간색입니다.",
        B: "공급업체에 전화하여 일정을 재확인하세요.",
        C: "네, 확인했습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 배송 시간 확인 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 28,
    questionText: "How should I respond to client complaints?",
    choices: {
      A: "Yes, they were upset.",
      B: "Politely acknowledge and offer solutions.",
      C: "It's part of the job.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객 불만에 어떻게 대응해야 하나요?",
      choices: {
        A: "네, 그들은 화가 났습니다.",
        B: "정중하게 인정하고 해결책을 제시하세요.",
        C: "그것은 업무의 일부입니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 고객 불만 대응 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 29,
    questionText: "How can we attract more customers online?",
    choices: {
      A: "It's a competitive market.",
      B: "By optimizing our website and ads.",
      C: "I saw their website.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "온라인에서 더 많은 고객을 어떻게 유치할 수 있을까요?",
      choices: {
        A: "경쟁이 치열한 시장입니다.",
        B: "웹사이트와 광고를 최적화하여 유치할 수 있습니다.",
        C: "그들의 웹사이트를 봤습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. B는 온라인 고객 유치 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 30,
    questionText: "How should we handle international shipments?",
    choices: {
      A: "Use the customs-approved delivery service.",
      B: "The shipment was delayed last time.",
      C: "I don't travel overseas often.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "국제 배송은 어떻게 처리해야 하나요?",
      choices: {
        A: "세관 승인된 배송 서비스를 이용하세요.",
        B: "지난번에는 배송이 지연되었습니다.",
        C: "저는 해외 여행을 자주 하지 않습니다.",
      },
    },
    explanation:
      "How로 시작하는 방법 의문문에는 구체적인 절차나 방법을 설명해야 합니다. A는 국제 배송 처리 방법을 명확하게 안내하며 적절히 답변했습니다.",
  },
  {
    questionNumber: 31,
    questionText: "How much is the registration fee for the event?",
    choices: {
      A: "The event starts at 10 a.m.",
      B: "It's $30 per participant.",
      C: "Yes, I already registered.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "행사 등록비는 얼마인가요?",
      choices: {
        A: "행사는 오전 10시에 시작합니다.",
        B: "참가자당 30달러입니다.",
        C: "네, 저는 이미 등록했습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. B는 등록비 금액을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 32,
    questionText: "How much do we need to pay for the service contract?",
    choices: {
      A: "The contract lasts for one year.",
      B: "We paid for it last month.",
      C: "It's approximately $2,000.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "서비스 계약에 얼마를 지불해야 하나요?",
      choices: {
        A: "계약은 1년 동안 유효합니다.",
        B: "지난달에 지불했습니다.",
        C: "약 2,000달러입니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. C는 서비스 계약 비용을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 33,
    questionText: "How much is the lunch set at this restaurant?",
    choices: {
      A: "It's on the second floor.",
      B: "The lunch set costs $12.",
      C: "I ate there last week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 레스토랑의 런치 세트는 얼마인가요?",
      choices: {
        A: "2층에 있습니다.",
        B: "런치 세트는 12달러입니다.",
        C: "저는 지난주에 거기서 식사했습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. B는 런치 세트의 가격을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 34,
    questionText: "How much are we charging for the workshop?",
    choices: {
      A: "About 50 dollars per person.",
      B: "I'm attending the workshop too.",
      C: "It's located in Room 4B.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "워크숍 참가비는 얼마로 책정되어 있나요?",
      choices: {
        A: "1인당 약 50달러입니다.",
        B: "저도 워크숍에 참석합니다.",
        C: "4B 강의실에서 진행됩니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. A는 워크숍 참가비를 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 35,
    questionText: "How much does the software license renewal cost?",
    choices: {
      A: "It expires in September.",
      B: "Around $180 annually.",
      C: "I downloaded it today.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "소프트웨어 라이선스 갱신 비용은 얼마인가요?",
      choices: {
        A: "9월에 만료됩니다.",
        B: "연간 약 180달러입니다.",
        C: "오늘 다운로드했습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. B는 라이선스 갱신 비용을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 36,
    questionText: "How much is left in our travel budget?",
    choices: {
      A: "We used most of it already.",
      B: "The budget meeting was yesterday.",
      C: "I submitted the request.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "출장 예산이 얼마나 남아있나요?",
      choices: {
        A: "대부분 이미 사용했습니다.",
        B: "예산 회의는 어제 있었습니다.",
        C: "요청서를 제출했습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 양이나 금액에 대한 정보를 요구합니다. A는 남은 예산의 상태에 대해 답변하여 적절히 대응했습니다.",
  },
  {
    questionNumber: 37,
    questionText: "How much will the catering service charge us?",
    choices: {
      A: "We confirmed the menu yesterday.",
      B: "It'll be roughly $700 total.",
      C: "The delivery is on Friday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "케이터링 서비스 비용은 얼마인가요?",
      choices: {
        A: "어제 메뉴를 확정했습니다.",
        B: "총 약 700달러가 될 것입니다.",
        C: "배달은 금요일에 있습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. B는 케이터링 서비스 비용을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 38,
    questionText: "How much is the refund for the canceled flight?",
    choices: {
      A: "$220 will be returned to your account.",
      B: "The flight was delayed three hours.",
      C: "I received the confirmation.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "취소된 항공편에 대한 환불 금액은 얼마인가요?",
      choices: {
        A: "220달러가 계좌로 환불될 예정입니다.",
        B: "항공편이 3시간 지연되었습니다.",
        C: "확인 메일을 받았습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. A는 환불 금액을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 39,
    questionText: "How much did the new equipment cost?",
    choices: {
      A: "It cost nearly $900.",
      B: "The equipment is very efficient.",
      C: "Yes, I installed it.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새 장비는 얼마였나요?",
      choices: {
        A: "거의 900달러였습니다.",
        B: "장비는 매우 효율적입니다.",
        C: "네, 제가 설치했습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. A는 장비 비용을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 40,
    questionText: "How much is our portion of the rent this month?",
    choices: {
      A: "I already paid mine.",
      B: "It comes to about $650.",
      C: "We moved in two weeks ago.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이번 달 우리가 부담할 임대료는 얼마인가요?",
      choices: {
        A: "저는 이미 제 몫을 지불했습니다.",
        B: "약 650달러 정도입니다.",
        C: "우리는 2주 전에 입주했습니다.",
      },
    },
    explanation:
      "How much로 시작하는 의문문은 가격이나 금액에 대한 정보를 요구합니다. B는 임대료 금액을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 41,
    questionText: "How can I install the new printer driver?",
    choices: {
      A: "Download it from the official website.",
      B: "The printer is next to the copier.",
      C: "Yes, I printed a test page.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새 프린터 드라이버는 어떻게 설치할 수 있나요?",
      choices: {
        A: "공식 웹사이트에서 다운로드하세요.",
        B: "프린터는 복사기 옆에 있습니다.",
        C: "네, 테스트 페이지를 인쇄했습니다.",
      },
    },
    explanation:
      "How can으로 시작하는 의문문은 방법이나 가능성에 대한 정보를 요구합니다. A는 프린터 드라이버 설치 방법을 명확하게 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 42,
    questionText: "How do we contact the maintenance team?",
    choices: {
      A: "I spoke with them this morning.",
      B: "Just dial 122 from any office phone.",
      C: "The issue was reported.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "유지보수팀에 어떻게 연락할 수 있나요?",
      choices: {
        A: "오늘 아침에 그들과 이야기했습니다.",
        B: "사무실 전화에서 122번으로 전화하세요.",
        C: "문제가 보고되었습니다.",
      },
    },
    explanation:
      "How do로 시작하는 의문문은 방법에 대한 정보를 요구합니다. B는 유지보수팀에 연락하는 구체적인 방법을 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 43,
    questionText: "How should I organize the client files?",
    choices: {
      A: "Yes, the files are important.",
      B: "Sort them by date and project name.",
      C: "They're in the cabinet.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객 파일을 어떻게 정리해야 하나요?",
      choices: {
        A: "네, 파일들은 중요합니다.",
        B: "날짜와 프로젝트 이름별로 정리하세요.",
        C: "캐비닛에 있습니다.",
      },
    },
    explanation:
      "How should로 시작하는 의문문은 권장되는 방법이나 절차에 대한 정보를 요구합니다. B는 파일 정리 방법을 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 44,
    questionText: "How are we delivering the presentation next week?",
    choices: {
      A: "We're using an online platform.",
      B: "Yes, the content has been finalized.",
      C: "The meeting is at 3 p.m.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다음 주 프레젠테이션은 어떻게 진행할 예정인가요?",
      choices: {
        A: "온라인 플랫폼을 사용할 예정입니다.",
        B: "네, 내용이 확정되었습니다.",
        C: "회의는 오후 3시입니다.",
      },
    },
    explanation:
      "How are로 시작하는 의문문은 방법이나 계획에 대한 정보를 요구합니다. A는 프레젠테이션 진행 방식을 명확하게 제시하여 적절히 답변했습니다. B는 발표 방식과 무관한 상태 보고이므로 부적절합니다.",
  },
  {
    questionNumber: 45,
    questionText: "How can I get approval for this expense?",
    choices: {
      A: "I submitted my expenses yesterday.",
      B: "Ask your supervisor to sign the form.",
      C: "The approval might take a week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 비용에 대한 승인을 어떻게 받을 수 있나요?",
      choices: {
        A: "어제 경비를 제출했습니다.",
        B: "상사에게 양식에 서명해달라고 요청하세요.",
        C: "승인은 일주일 정도 걸릴 수 있습니다.",
      },
    },
    explanation:
      "How can으로 시작하는 의문문은 방법이나 가능성에 대한 정보를 요구합니다. B는 비용 승인을 받는 구체적인 방법을 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 46,
    questionText: "How should I respond to the customer complaint?",
    choices: {
      A: "The customer left already.",
      B: "Politely acknowledge and offer a solution.",
      C: "I wasn't working that day.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객 불만에 어떻게 대응해야 하나요?",
      choices: {
        A: "고객은 이미 떠났습니다.",
        B: "정중하게 인정하고 해결책을 제시하세요.",
        C: "그날 근무하지 않았습니다.",
      },
    },
    explanation:
      "How should로 시작하는 의문문은 권장되는 방법이나 절차에 대한 정보를 요구합니다. B는 고객 불만 대응 방법을 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 47,
    questionText: "How do you plan to meet the project deadline?",
    choices: {
      A: "By working overtime this weekend.",
      B: "I like the project team.",
      C: "The deadline is October 15th.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프로젝트 마감일을 어떻게 맞출 계획인가요?",
      choices: {
        A: "이번 주말에 초과 근무를 함으로써.",
        B: "프로젝트 팀이 마음에 듭니다.",
        C: "마감일은 10월 15일입니다.",
      },
    },
    explanation:
      "How do로 시작하는 의문문은 방법이나 계획에 대한 정보를 요구합니다. A는 마감일을 맞추기 위한 구체적인 계획을 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 48,
    questionText: "How can I reserve the meeting room?",
    choices: {
      A: "The meeting room is on the second floor.",
      B: "Yes, the meeting went well.",
      C: 'Just check the calendar and click "Reserve."',
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "회의실을 어떻게 예약할 수 있나요?",
      choices: {
        A: "회의실은 2층에 있습니다.",
        B: "네, 회의는 잘 진행되었습니다.",
        C: '캘린더를 확인하고 "예약" 버튼을 클릭하세요.',
      },
    },
    explanation:
      "How can으로 시작하는 의문문은 방법이나 가능성에 대한 정보를 요구합니다. C는 회의실 예약 방법을 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 49,
    questionText: "How do we report safety issues?",
    choices: {
      A: "The report was submitted yesterday.",
      B: "Yes, safety is important.",
      C: "Fill out the incident form and email it to HR.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "안전 문제는 어떻게 보고하나요?",
      choices: {
        A: "보고서는 어제 제출되었습니다.",
        B: "네, 안전은 중요합니다.",
        C: "사고 양식을 작성하여 인사부에 이메일로 보내세요.",
      },
    },
    explanation:
      "How do로 시작하는 의문문은 방법이나 절차에 대한 정보를 요구합니다. A는 시제 불일치가 있고 질문에 직접적인 응답이 아닙니다. C는 안전 문제 보고 방법을 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 50,
    questionText: "How are you handling the late shipment?",
    choices: {
      A: "I haven't seen the shipment yet.",
      B: "We're contacting the supplier directly.",
      C: "It arrived this morning.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "지연된 배송을 어떻게 처리하고 있나요?",
      choices: {
        A: "아직 배송품을 보지 못했습니다.",
        B: "공급업체에 직접 연락하고 있습니다.",
        C: "오늘 아침에 도착했습니다.",
      },
    },
    explanation:
      "How are로 시작하는 의문문은 현재 진행 중인 방법이나 상태에 대한 정보를 요구합니다. B는 지연된 배송 처리 방법을 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 51,
    questionText: "How many people are attending the workshop?",
    choices: {
      A: "About 15 employees.",
      B: "The workshop starts at 2.",
      C: "I went to the last one.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "워크숍에 몇 명이 참석하나요?",
      choices: {
        A: "약 15명의 직원들입니다.",
        B: "워크숍은 2시에 시작합니다.",
        C: "저는 지난번에 갔었습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. A는 워크숍 참석자 수에 대한 정확한 정보를 제공하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 52,
    questionText: "How many chairs should I bring to the meeting room?",
    choices: {
      A: "You can arrange them in a circle.",
      B: "Bring at least twelve.",
      C: "The meeting was canceled.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회의실에 의자를 몇 개 가져가야 하나요?",
      choices: {
        A: "원형으로 배치할 수 있습니다.",
        B: "최소 열두 개를 가져오세요.",
        C: "회의가 취소되었습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. B는 필요한 의자의 수를 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 53,
    questionText: "How many boxes did we receive this morning?",
    choices: {
      A: "I'll check the delivery log.",
      B: "The boxes are all sealed.",
      C: "We received eight.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "오늘 아침에 박스를 몇 개 받았나요?",
      choices: {
        A: "배송 기록을 확인해 보겠습니다.",
        B: "박스는 모두 봉인되어 있습니다.",
        C: "여덟 개를 받았습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. C는 받은 박스의 정확한 수량을 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 54,
    questionText: "How many interns will join the team this summer?",
    choices: {
      A: "There will be five in total.",
      B: "Yes, they're university students.",
      C: "The internship starts in June.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이번 여름에 몇 명의 인턴이 팀에 합류하나요?",
      choices: {
        A: "총 다섯 명이 될 것입니다.",
        B: "네, 그들은 대학생들입니다.",
        C: "인턴십은 6월에 시작됩니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. A는 합류할 인턴의 정확한 수를 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 55,
    questionText: "How many staff members are on duty tonight?",
    choices: {
      A: "There are three scheduled.",
      B: "The night shift begins at 9.",
      C: "I'll be working from home next week.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 밤에 몇 명의 직원이 근무하나요?",
      choices: {
        A: "세 명이 예정되어 있습니다.",
        B: "야간 근무는 9시에 시작합니다.",
        C: "저는 다음 주에 재택근무를 할 예정입니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. A는 근무 예정인 직원의 정확한 수를 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 56,
    questionText: "How many copies do we need for the meeting?",
    choices: {
      A: "I made ten just in case.",
      B: "The printer is out of ink.",
      C: "I emailed the file to you.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의를 위해 몇 부의 사본이 필요한가요?",
      choices: {
        A: "혹시 모르니 열 부를 만들었습니다.",
        B: "프린터에 잉크가 떨어졌습니다.",
        C: "파일을 이메일로 보냈습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. A는 필요한 사본의 수량을 언급하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 57,
    questionText: "How many presentations are scheduled today?",
    choices: {
      A: "I'll be presenting on sales.",
      B: "Four are listed on the agenda.",
      C: "The room has a projector.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 몇 개의 발표가 예정되어 있나요?",
      choices: {
        A: "제가 판매에 대해 발표할 예정입니다.",
        B: "의제에 네 개가 나열되어 있습니다.",
        C: "방에는 프로젝터가 있습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. B는 예정된 발표의 정확한 수를 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 58,
    questionText: "How many visitors are we expecting this afternoon?",
    choices: {
      A: "They'll be in the lobby.",
      B: "Ten, including two clients.",
      C: "I gave the tour yesterday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "오늘 오후에 몇 명의 방문객이 올 예정인가요?",
      choices: {
        A: "그들은 로비에 있을 것입니다.",
        B: "두 명의 고객을 포함해 열 명입니다.",
        C: "어제 투어를 안내했습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. B는 예상되는 방문객의 정확한 수를 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 59,
    questionText: "How many applications did we receive?",
    choices: {
      A: "I received the file late.",
      B: "Yes, the deadline passed.",
      C: "Over fifty, according to HR.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "지원서를 몇 개나 받았나요?",
      choices: {
        A: "파일을 늦게 받았습니다.",
        B: "네, 마감일이 지났습니다.",
        C: "인사부에 따르면 50개 이상입니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. C는 받은 지원서의 수량을 구체적으로 제시하여 적절히 답변했습니다.",
  },
  {
    questionNumber: 60,
    questionText: "How many units were sold this quarter?",
    choices: {
      A: "The quarterly report is ready.",
      B: "We sold about 2,000.",
      C: "I'll call the sales team.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이번 분기에 몇 개의 제품이 판매되었나요?",
      choices: {
        A: "분기 보고서가 준비되었습니다.",
        B: "약 2,000개를 판매했습니다.",
        C: "영업팀에 전화하겠습니다.",
      },
    },
    explanation:
      "How many로 시작하는 의문문은 수량에 대한 정보를 요구합니다. B는 판매된 제품의 정확한 수량을 제시하여 적절히 답변했습니다.",
  },
];
